import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';

@Component({
    selector: 'nlr-attachments-modal',
    imports: [],
    templateUrl: './field-record-lodgement-success-modal.component.html',
    styleUrls: ['../modal.scss', './field-record-lodgement-success-modal.component.scss']
})
export class FieldRecordLodgementSuccessModalComponent implements ModalComponent {
    modalClosed: EventEmitter<string> = new EventEmitter<string>();
    modalSize: string = 'modal-md';
    title: string = undefined;
    message: string = undefined;

    close() {
        this.modalClosed.emit('close');
    }
}
